export const inFlyinPage = () => {
  const pathName = window.location.pathname;
  const hostName = window.location.hostname;
  return (
    pathName.toLowerCase() === "/travelsafe/flyin" ||
    pathName.toLowerCase() === "/travelsafe/flyin/" ||
    (hostName === "www.flyin.com" &&
      (pathName.toLowerCase() === "/travelsafe" ||
        pathName.toLowerCase() === "/travelsafe/")) ||
    (hostName === "flyin.com" &&
      (pathName.toLowerCase() === "/travelsafe" ||
        pathName.toLowerCase() === "/travelsafe/")) ||
    hostName === "qa2.flyin.com"
  );
};

export const align = () => {
  let query = new URLSearchParams(window.location.search);
  if (query.get("lng") !== "en" && inFlyinPage()) {
    return "rtl";
  }
  return "ltr";
};

export const getArabicFontStyle = () => {
  if (align() === "rtl")
    return {
      fontFamily:
        "DroidArabicKufiRegular,-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen','Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',	sans-serif",
    };
};
